// Montant en francs CFA (XOF), ex. « 10 000 FCFA ». Les prix viennent du catalogue
// (catalogue_tarifs) via le serveur, jamais d'une constante du code.
export const formatFcfa = (montant) => {
  const n = Number(montant);
  if (!Number.isFinite(n)) return '—';
  return `${Math.round(n).toLocaleString('fr-FR')} FCFA`;
};
